export const aiListTextToArray = (text) => {
    // Initialize as string
    text = !text ? `` : String(text);
    // Trim
    text = text?.trim();
    // Remove preamble
    if (text.indexOf("Here is a") === 0) text = text.substring(text.indexOf(":") + 1);
    if (text.indexOf("Here's a") === 0) text = text.substring(text.indexOf(":") + 1);
    // Trim
    text = text?.trim();
    // Remove numbered list bullets (e.g., "1. ", "2) ", "3- ", etc.)
    text = text.replace(/^\s*\d+[\.\)\-]\s+/gm, '');
    // Remove unordered list bullets (e.g., "• ", "- ", "– ", "* ", etc.)
    text = text.replace(/^\s*[\u2022\u2023\u25E6\u2043\u2219\*\-\–]\s+/gm, '');
    // Return as array
    return text?.split('\n');
}

export const aiJsonTextToArray = (input) => {
  // getByQueryChat now returns an already-parsed object/array on the
  // json_schema path, not a string. Extract the array directly (reusing the
  // "first array property" logic below) instead of stringifying it.
  if (Array.isArray(input)) return input;
  if (input && typeof input === "object") {
    for (const key in input) {
      if (Array.isArray(input[key])) {
        return input[key];
      }
    }
    return [];
  }

  // Initialize as string
  let text = !input ? `` : String(input);

  // Trim whitespace
  text = text?.trim();
  
  // Check if the text is wrapped in markdown code block
  const jsonRegex = /```(?:json)?\s*([\s\S]*?)\s*```/;
  const match = text.match(jsonRegex);
  
  if (match) {
    // Extract the JSON content from the code block
    text = match[1].trim();
  }
  
  try {
    // Parse the JSON string to get the array
    const parsedArray = JSON.parse(text);
    
    // Ensure the result is an array
    if (Array.isArray(parsedArray)) {
      return parsedArray;
    } else {
      // If the parsed result is not an array but an object with an array property
      // (common in AI responses), try to find an array property
      for (const key in parsedArray) {
        if (Array.isArray(parsedArray[key])) {
          return parsedArray[key];
        }
      }
      // If no array found, return an empty array
      return [];
    }
  } catch (error) {
    // If parsing fails, return an empty array
    console.error("Failed to parse JSON string:", error);
    return [];
  }
}
